import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useFormContext } from 'react-hook-form';

import AlertMessage from '@components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import RadioButtons from '@lib/inputs/RadioButtons';

import { IVoterRegistrationFormValues } from '../voterRegistrationTypes';
import { VoterRegistrationFormError } from '../VoterRegistrationFormError';
import useVoterRegistration from '../useVoterRegistration';

function VotingEligibilitySection() {
    const {
        watch,
        formState: { errors },
        setValue,
    } = useFormContext<IVoterRegistrationFormValues>();

    const { VOTER_REGISTRATION_CHOICES } = useVoterRegistration();

    const handleFieldChange = (name: keyof IVoterRegistrationFormValues, value: string) => {
        setValue(name, value, {
            shouldValidate: true,
            shouldDirty: true,
        });
    };

    return (
        <>
            <FormattedMessage id="voterRegistration.form.votingEligibility.title" tagName="h2" />
            <AlertMessage
                type={'info'}
                content={
                    <FormattedMessage
                        id="voterRegistration.form.votingEligibility.alert"
                        values={{ strong: (chunks: any) => <strong>{chunks}</strong> }}
                    />
                }
                showIcon={true}
                icon={'info-circle'}
            />
            <div>
                <div id="isUSCitizen-section">
                    <RadioButtons
                        legend={{
                            legendText: (
                                <FormattedMessage id="voterRegistration.form.votingEligibility.areYouUSCitizen" />
                            ),
                        }}
                        label={{
                            id: 'isUSCitizen',
                            name: 'isUSCitizen',
                            showRequiredIcon: true,
                            labelClass: ['gi-radio_buttons'],
                        }}
                        inputData={{
                            id: 'isUSCitizen',
                            isInputRequired: true,
                            options: VOTER_REGISTRATION_CHOICES.YES_NO,
                            type: 'radio_buttons',
                            value: watch('isUSCitizen'),
                        }}
                        inputActions={{
                            handleFieldChange: val => handleFieldChange('isUSCitizen', val),
                        }}
                    />
                    <VoterRegistrationFormError
                        name="isUSCitizen"
                        hasError={!!errors.isUSCitizen}
                        messageId={errors.isUSCitizen?.message}
                    />
                </div>
                <div id="isAgeAbove18yr-section">
                    <RadioButtons
                        legend={{
                            legendText: (
                                <FormattedMessage id="voterRegistration.form.votingEligibility.areYou18YrsOld" />
                            ),
                        }}
                        label={{
                            id: 'isAgeAbove18yr',
                            name: 'isAgeAbove18yr',
                            showRequiredIcon: true,
                            labelClass: ['gi-radio_buttons'],
                        }}
                        inputData={{
                            id: 'isAgeAbove18yr',
                            isInputRequired: true,
                            options: VOTER_REGISTRATION_CHOICES.YES_NO,
                            type: 'radio_buttons',
                            value: watch('isAgeAbove18yr'),
                        }}
                        inputActions={{
                            handleFieldChange: val => handleFieldChange('isAgeAbove18yr', val),
                        }}
                    />
                    <VoterRegistrationFormError
                        name="isAgeAbove18yr"
                        hasError={!!errors.isAgeAbove18yr}
                        messageId={errors.isAgeAbove18yr?.message}
                    />
                </div>
            </div>
        </>
    );
}

export default VotingEligibilitySection;
